import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Guest from '../views/Guest.vue'
import Agenda from '../views/Agenda.vue'
import AgendaView from '../views/Agenda-view.vue'

Vue.use(VueRouter)

const routes = [

  {
    path: '*',
    redirect: '/2022'
  },
  {
    path: '/2022',
    name: 'home',
    component: HomeView
  },
  {
    path: '/2022/guest',
    name: 'guest',
    component: Guest
  },
  {
    path: '/2022/agenda',
    name: 'Agenda',
    component: Agenda
  },
  {
    path: '/2022/agendaview/:zone_id',
    name: 'agendaview',
    component: AgendaView
  }
]
const router = new VueRouter({
  routes,
  mode: 'history',
  // base: '/2022/',
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
});
export default router
